<template>
    <span class="profile-pic">
        <v-img :src="imageUrl"></v-img>
    </span>
</template>

<script setup lang="ts">
const props = defineProps({
    imageUrl: String,
});
</script>